import React from 'react'
import PropTypes from 'prop-types'

import { formatGradeLevelLabels } from '../../../utils/readability'
import { isMaxOrMinGradeLevel } from '../../../utils/readability'

const GradeLevelScores = props => (
  <div className="grade-level-scores">
    {props.gradeLevelScores.map((score, i) => {
      let key = Object.keys(score)[0]
      return (
        <div className="grade-level-score" key={i}>
          <div className="label">{formatGradeLevelLabels(key)}</div>
          <div className="line" />
          <div
            className={`value ${
              isMaxOrMinGradeLevel(score[key], props.gradeLevelScores)
                ? 'bold'
                : ''
            }`}
          >
            {score[key]}
          </div>
        </div>
      )
    })}
  </div>
)

GradeLevelScores.propTypes = {
  gradeLevelScores: PropTypes.array.isRequired
}

export default GradeLevelScores



// WEBPACK FOOTER //
// ./src/components/quest/readability/GradeLevelScores.js